import gql from "graphql-tag";

export const GET_RECENTLY_ORDER_ITEM_DETAILS = gql`
  query getRecentlyOrderedItemDetails(
    $mobileNumber: String
    $patientId: String
    $cityId: Int!
    $pincode: Int
  ) {
    getRecentlyOrderedItemDetails(
      mobileNumber: $mobileNumber
      patientId: $patientId
      cityId: $cityId
      pincode: $pincode
    ) {
      recentlyOrderedItems {
        id
        itemId
        itemName
        gender
        rate
        itemRemarks
        city
        state
        itemType
        fromAgeInDays
        toAgeInDays
        testPreparationData
        collectionType
        totalSavings
        extraInclusionsCount
        price
        imageUrl
        testDescription
        inclusions
        packageCalculatedMrp
        canonicalTag
        totalSavings
        extraInclusionsCount
        price
        imageUrl
        allObservations {
          observationName
          mandatoryValue
          isHeader
          PrintOrder
        }
        diagnosticPricing {
          mrp
          price
          groupPlan
          startDate
          endDate
          status
          couponCode
          showSlashedPrice
          showDiscountPercent
          additionalCircleCashback {
            cashbackType
            cashbackValue
            offerDescription
            cashbackAmount
          }
        }
        diagnosticInclusions {
          name
          itemId
          allObservations {
            observationName
            mandatoryValue
            isHeader
            PrintOrder
          }
        }
        subCategoryList
        productScore
      }
      frequentlyOrderedItems {
        id
        itemId
        itemName
        gender
        rate
        itemRemarks
        city
        state
        itemType
        fromAgeInDays
        toAgeInDays
        testPreparationData
        collectionType
        totalSavings
        extraInclusionsCount
        price
        imageUrl
        testDescription
        inclusions
        packageCalculatedMrp
        canonicalTag
        totalSavings
        extraInclusionsCount
        price
        imageUrl
        allObservations {
          observationName
          mandatoryValue
          isHeader
          PrintOrder
        }
        diagnosticPricing {
          mrp
          price
          groupPlan
          startDate
          endDate
          status
          couponCode
          showSlashedPrice
          showDiscountPercent
          additionalCircleCashback {
            cashbackType
            cashbackValue
            offerDescription
            cashbackAmount
          }
        }
        diagnosticInclusions {
          name
          itemId
          allObservations {
            observationName
            mandatoryValue
            isHeader
            PrintOrder
          }
        }
        subCategoryList
        productScore
      }
    }
  }
`;

export const GET_ORDER_LEVEL_DIAGNOSTIC_STATUS = gql`
  query getHCOrderFormattedTrackingHistory($diagnosticOrderID: String) {
    getHCOrderFormattedTrackingHistory(diagnosticOrderID: $diagnosticOrderID) {
      statusHistory {
        statusDate
        orderStatus
        subStatus
        attributes {
          itemsModified {
            itemName
            itemId
            price
            isRemoved
          }
          refund {
            amount
            txnID
            status
            reason
            items {
              itemName
              itemId
              price
              isRemoved
            }
          }
        }
      }
      statusInclusions {
        id
        statusDate
        orderStatus
        itemId
        packageId
        itemName
        packageName
        hideStatus
        statusMessage
      }
      upcomingStatuses {
        orderStatus
      }
      groupedPendingReportInclusions {
        inclusions {
          itemId
          itemName
          orderStatus
          reportTATMessage
          reportTATMessage
        }
        reportTATMessage
        isReportPending
      }
    }
  }
`;

export const SAVE_PHLEBO_FEEBACK = gql`
  mutation savePhleboFeedback(
    $diagnosticOrdersId: String!
    $phleboRating: Int!
    $phleboFeedback: String
    $patientComments: String
  ) {
    savePhleboFeedback(
      diagnosticOrdersId: $diagnosticOrdersId
      phleboRating: $phleboRating
      phleboFeedback: $phleboFeedback
      patientComments: $patientComments
    ) {
      status
    }
  }
`;

export const SAVE_CSAT_RATING = gql`
  mutation saveDiagnosticCSATRating(
    $feedback: String
    $orderId: String!
    $rating: CSATFeedback!
  ) {
    saveDiagnosticCSATRating(
      orderId: $orderId
      rating: $rating
      feedback: $feedback
    ) {
      status
    }
  }
`;

export const RESCHEDULE_DIAGNOSTICS_ORDER_V2 = gql`
  mutation rescheduleDiagnosticsOrderv2(
    $parentOrderID: ID!
    $slotInfo: slotInfo!
    $selectedDate: Date!
    $comment: String
    $reason: String!
    $source: DiagnosticsRescheduleSource
  ) {
    rescheduleDiagnosticsOrderv2(
      parentOrderID: $parentOrderID
      slotInfo: $slotInfo
      selectedDate: $selectedDate
      comment: $comment
      reason: $reason
      source: $source
    ) {
      status
      message
      rescheduleCount
    }
  }
`;

export const CANCEL_DIAGNOSTICS_ORDER = gql`
  mutation cancelDiagnosticOrdersv2(
    $cancellationDiagnosticsInput: CancellationDiagnosticsInputv2
  ) {
    cancelDiagnosticOrdersv2(
      cancellationDiagnosticsInput: $cancellationDiagnosticsInput
    ) {
      status
      message
      isDirectCancellation
    }
  }
`;

export const GET_DIAGNOSTIC_ORDERSLIST_BY_PARENT_ORDER_ID = gql`
  query getDiagnosticOrdersListByParentOrderID($parentOrderID: String!) {
    getDiagnosticOrdersListByParentOrderID(parentOrderID: $parentOrderID) {
      ordersCount
      ordersList {
        displayId
        slotDateTimeInUTC
        diagnosticDate
        patientId
        totalPrice
        patientObj {
          id
          firstName
          lastName
        }
        diagnosticOrderLineItems {
          id
          itemId
          itemName
          quantity
          price
          editOrderID
          isRemoved
          groupPlan
          itemName
          diagnostics {
            id
            itemId
            itemName
            inclusions
          }
          pricingObj {
            mrp
            price
            groupPlan
          }
          itemObj {
            preTestingRequirement
            reportGenerationTime
          }
        }
      }
    }
  }
`;

export const GET_RESCHEDULE_AND_CANCELLATION_REASONS = gql`
  query getRescheduleAndCancellationReasons(
    $appointmentDateTimeInUTC: DateTime
  ) {
    getRescheduleAndCancellationReasons(
      appointmentDateTimeInUTC: $appointmentDateTimeInUTC
    ) {
      rescheduleReasons
      cancellationReasons
      cancellationReasonsv2 {
        reason
        isDirectCancellation
        ctaOptions {
          cta
          ctas
          multiCtas
          displayText
          userCommentsEnabled
        }
      }
    }
  }
`;

export const SWITCH_DIAGNOSTIC_ORDER_PATIENT_ID = gql`
  mutation switchDiagnosticOrderPatientID(
    $diagnosticOrdersId: String!
    $newPatientId: String!
  ) {
    switchDiagnosticOrderPatientID(
      diagnosticOrdersId: $diagnosticOrdersId
      newPatientId: $newPatientId
    ) {
      status
      message
    }
  }
`;

export const GET_DIAGNOSTIC_ORDERS_LIST_BY_MOBILE = gql`
  query getDiagnosticOrdersListByMobile(
    $mobileNumber: String!
    $patientId: String
    $paginated: Boolean
    $limit: Int
    $offset: Int
  ) {
    getDiagnosticOrdersListByMobile(
      mobileNumber: $mobileNumber
      patientId: $patientId
      offset: $offset
      limit: $limit
      paginated: $paginated
    ) {
      cancellationRequestedDisplayText
      ordersList {
        id
        primaryOrderID
        resampledOrderId
        parentOrderId
        isRescheduled
        isNonCartOrder
        rescheduleCount
        areaId
        city
        cityId
        updatedDate
        preBookingId
        prescriptionItemsObj {
          comments
          prescriptions {
            prescriptionItems {
              itemId
              itemName
            }
            prescriptionName
            prescriptionUrl
          }
        }
        patientObj {
          firstName
          lastName
          gender
        }
        attachmentData {
          fileName
          documentName
          documentBase64String
        }
        attributesObj {
          preTestingRequirement
          reportGenerationTime
          expectedReportGenerationTime
          reportTATMessage
          isMultiUhid
          slotDurationInMinutes
          homeCollectionCharges
        }
        addressType
        addressLine1
        addressLine2
        patientId
        patientObj {
          id
          uhid
          firstName
          lastName
          gender
          dateOfBirth
        }
        displayId
        deviceType
        diagnosticDate
        diagnosticBranchCode
        diagnosticEmployeeCode
        parentOrderId
        csatRating
        diagnosticOrderPhlebotomists {
          phleboRating
          phleboOTP
          checkinDateTime
          phleboTrackLink
          diagnosticPhlebotomists {
            id
            name
            mobile
            vaccinationStatus
            profilePic
            rating
          }
          isPhleboETAElapsed
          phleboETAElapsedMessage
          showPhleboDetails
          phleboDetailsETAText
          isPhleboChanged
        }
        diagnosticOrdersStatus {
          id
          orderStatus
          statusDate
          itemId
          packageId
          itemName
          packageName
          hideStatus
          statusMessage
        }
        diagnosticOrderLineItems {
          quantity
          itemName
          groupPlan
          itemId
          isRemoved
          editOrderID
          itemObj {
            gender
          }
          pricingObj {
            mrp
            price
            groupPlan
          }
          rejectedItems {
            effectiveAmountPaid
            itemId
            itemName
          }
          refundEligibleItems {
            effectiveAmountPaid
            itemId
            itemName
          }
          diagnostics {
            rate
            state
            itemName
            itemRemarks
            toAgeInDays
            canonicalTag
            fromAgeInDays
            diagnosticPricing {
              status
              endDate
              groupPlan
              startDate
              mrp
              showSlashedPrice
              showDiscountPercent
              additionalCircleCashback {
                cashbackType
                cashbackValue
                offerDescription
                cashbackAmount
              }
            }
            packageCalculatedMrp
            testPreparationData
          }
          testPreparationData
          packageCalculatedMrp
        }
        totalPrice
        centerName
        centerState
        orderStatus
        createdDate
        paymentType
        diagnosticDate
        centerLocality
        paymentOrderId
        patientAddressId
        phleboDetailsObj {
          PhelboOTP
          PhelbotomistName
          PhelbotomistMobile
          PhelbotomistTrackLink
        }
        slotDateTimeInUTC
        collectionCharges
        diagnosticBranchCode
        diagnosticEmployeeCode
        diagnosticOrderReschedule {
          patientId
          createdDate
          updatedDate
          rescheduleDate
          rescheduleReason
          diagnosticOrdersId
          rescheduleDateTimeInUTC
        }
        diagnosticOrderCancellation {
          patientId
          cancelType
          createdDate
          updatedDate
          cancelByName
          diagnosticOrdersId
          cancellationReason
          comments
        }
        diagnosticOrderPaymentLinks {
          paymentLinkURL
          paymentLinkMessage
        }
      }
      ordersCount
      ordersListWithResampleConfig {
        id
        refund
        resample
      }
    }
  }
`;

export const GET_DIAG_BULK_PACKAGE_RECOMMENDATIONS = gql`
  query GetDiagnosticPackageRecommendationsBulk(
    $getDiagnosticPackageRecommendationsBulkInput: [GetDiagnosticPackageRecommendationsRequest]!
    $testRecommendationsEnabled: Boolean
  ) {
    getDiagnosticPackageRecommendationsBulk(
      getDiagnosticPackageRecommendationsBulkInput: $getDiagnosticPackageRecommendationsBulkInput
      testRecommendationsEnabled: $testRecommendationsEnabled
    ) {
      packageRecommendationsBulk {
        patientId
        packageRecommendations {
          id
          itemId
          itemName
          gender
          rate
          itemRemarks
          itemType
          testPreparationData
          collectionType
          testDescription
          inclusions
          includedItemIds
          canonicalTag
          packageCalculatedMrp
          totalSavings
          extraInclusionsCount
          packageHeader
          price
          diagnosticInclusions {
            itemId
            name
            allObservations {
              observationId
              observationName
              mandatoryValue
              isHeader
              PrintOrder
            }
          }
          diagnosticInclusionsv2 {
            name
            itemId
            observationsv2 {
              observationId
              observationName
              isHeader
              PrintOrder
              mandatoryValue
            }
            allObservationsv2 {
              observationId
              observationName
              isHeader
              PrintOrder
              mandatoryValue
            }
          }
          observationsv2 {
            observationId
            observationName
            isHeader
            PrintOrder
            mandatoryValue
          }
          allObservationsv2 {
            observationName
            isHeader
            PrintOrder
            mandatoryValue
            observationName
          }
          diagnosticPricing {
            mrp
            price
            groupPlan
            status
            startDate
            endDate
            showSlashedPrice
            showDiscountPercent
            additionalCircleCashback {
              cashbackType
              cashbackValue
              offerDescription
              cashbackAmount
            }
          }
          allObservations {
            observationName
            mandatoryValue
            isHeader
            PrintOrder
          }
        }
      }
    }
  }
`;

export const GET_DIAGNOSTIC_ORDER_LIST_DETAILS = gql`
  query GetDiagnosticOrderDetails($diagnosticOrderId: String) {
    getDiagnosticOrderDetails(diagnosticOrderId: $diagnosticOrderId) {
      refund
      resample
      ordersList {
        areaId
        id
        primaryOrderID
        primaryDisplayID
        patientAddressId
        addressLine1
        addressLine2
        addressType
        city
        cityId
        zipcode
        isRescheduled
        rescheduleCount
        slotTimings
        employeeSlotId
        diagnosticEmployeeCode
        diagnosticBranchCode
        totalPrice
        prescriptionUrl
        diagnosticDate
        centerName
        centerCode
        centerCity
        centerState
        centerLocality
        couponCashbackAmount
        isCircleCoupon
        homeCollectionChargesSaved
        orderStatus
        orderType
        displayId
        createdDate
        collectionCharges
        couponCode
        couponDiscAmount
        paymentType
        paymentOrderId
        slotDateTimeInUTC
        visitNo
        slotId
        stateId
        patientId
        invoiceURL
        parentOrderId
        passportNo
        attributesObj {
          preTestingRequirement
          reportGenerationTime
          expectedReportGenerationTime
          reportTATMessage
          initialCollectionCharges
          isMultiUhid
          distanceCharges
          slotDurationInMinutes
          homeCollectionCharges
          downsellTransaction
        }
        patientAddressObj {
          addressLine1
          addressLine2
          addressType
          zipcode
          landmark
          latitude
          longitude
          city
          state
        }
        csatRating
        diagnosticOrderPhlebotomists {
          phleboRating
          phleboOTP
          checkinDateTime
          phleboTrackLink
          diagnosticPhlebotomists {
            id
            name
            mobile
            vaccinationStatus
            profilePic
            rating
          }
          isPhleboETAElapsed
          phleboETAElapsedMessage
          showPhleboDetails
          phleboDetailsETAText
          isPhleboChanged
        }
        patientObj {
          id
          uhid
          firstName
          lastName
          gender
          dateOfBirth
        }
        diagnosticOrderRefunds {
          createdDate
          amountRefunded
          diagnosticOrdersId
          itemIDs
        }
        diagnosticOrderLineItems {
          id
          itemId
          itemName
          quantity
          price
          editOrderID
          isRemoved
          groupPlan
          circleCashbackAmount
          couponDiscAmount
          diagnostics {
            id
            itemId
            itemName
            inclusions
            itemType
          }
          pricingObj {
            mrp
            price
            groupPlan
            status
          }
          itemObj {
            preTestingRequirement
            reportGenerationTime
            packageCalculatedMrp
            testPreparationData
          }
          rejectedItems {
            itemId
            itemName
            mrp
            price
            groupPlan
            effectiveAmountPaid
          }
          refundEligibleItems {
            itemId
            itemName
            mrp
            price
            groupPlan
            effectiveAmountPaid
          }
        }
        diagnosticOrdersStatus {
          id
          orderStatus
          statusDate
          itemId
          packageId
          itemName
          packageName
          hideStatus
          statusMessage
        }
        labReportURL
        totalCircleCashback
        diagnosticOrderTransactions {
          healthCreditsUsed
          paymentMethod
          paymentStatus
          effectivePrepaidAmount
          prepaidAmount
          offers {
            offer_id
            offer_code
            offer_description {
              sponsored_by
              title
              tnc
              description
            }
            status
            benefits {
              type
              amount
              calculation_info {
                value
                max_amount
                calculation_rule
              }
            }
          }
        }
        diagnosticOrderPaymentLinks {
          paymentLinkURL
          paymentLinkMessage
        }
      }
    }
  }
`;

export const GET_DIAGNOSTICS_HC_CHARGES_V2 = gql`
  query getPhleboCharges($chargeDetailsInput: ChargeDetailsInput) {
    getPhleboCharges(chargeDetailsInput: $chargeDetailsInput) {
      charges
      distanceCharges
    }
  }
`;

export const SAVE_MODIFY_DIAGNOSTIC_ORDER = gql`
  mutation saveModifyDiagnosticOrder(
    $saveModifyDiagnosticOrder: saveModifyDiagnosticOrderInput!
  ) {
    saveModifyDiagnosticOrder(
      saveModifyDiagnosticOrder: $saveModifyDiagnosticOrder
    ) {
      orderId
      displayId
      status
      errorMessageToDisplay
      attributes {
        itemids
        conflictedItems {
          itemToKeep
          itemsWithConflicts
        }
      }
    }
  }
`;

export const SAVE_MODIFY_DIAGNOSTIC_ORDER_V1 = gql`
  mutation saveModifyDiagnosticOrderV1(
    $saveModifyDiagnosticOrder: saveModifyDiagnosticOrderInput!
  ) {
    saveModifyDiagnosticOrderV1(
      saveModifyDiagnosticOrder: $saveModifyDiagnosticOrder
    ) {
      displayId
      errorMessageToDisplay
      orderId
      status
      paymentLink
      attributes {
        itemids
        conflictedItems {
          itemToKeep
          itemsWithConflicts
        }
      }
    }
  }
`;

export const SAVE_BOOK_HOME_COLLECTION_ORDER_V2 = gql`
  mutation saveDiagnosticBookHCOrderv2(
    $diagnosticOrderInput: SaveBookHomeCollectionOrderInputv2
  ) {
    saveDiagnosticBookHCOrderv2(diagnosticOrderInput: $diagnosticOrderInput) {
      patientsObjWithOrderIDs {
        status
        patientID
        amount
        orderID
        displayID
        errorMessageToDisplay
        attributes {
          itemids
          conflictedItems {
            itemToKeep
            itemsWithConflicts
          }
        }
      }
    }
  }
`;

export const WRAPPER_PROCESS_DIAGNOSTIC_HC_ORDER_COD = gql`
  mutation wrapperProcessDiagnosticHCOrderCOD(
    $processDiagnosticHCOrdersInput: [ProcessDiagnosticHCOrderInputCOD]
  ) {
    wrapperProcessDiagnosticHCOrderCOD(
      processDiagnosticHCOrdersInput: $processDiagnosticHCOrdersInput
    ) {
      result {
        status
        preBookingID
        message
      }
    }
  }
`;

export const FIND_DIAGNOSTIC_SETTINGS = gql`
  query findDiagnosticSettings(
    $cityId: Int
    $latitude: Float
    $longitude: Float
    $slotByClusterConfig: Boolean
  ) {
    findDiagnosticSettings(
      cityId: $cityId
      latitude: $latitude
      longitude: $longitude
      slotByClusterConfig: $slotByClusterConfig
    ) {
      phleboETAInMinutes
      maxAllowedUhidsCount
      maxUhidsLimitExceededMessage
      slotDaysByCity
    }
  }
`;

export const VALIDATE_DIAGNOSTIC_COUPON = gql`
  mutation vaidateDiagnosticCoupon($couponInput: CouponInput) {
    vaidateDiagnosticCoupon(couponInput: $couponInput) {
      status
      message
      uniqueid
      couponcode
    }
  }
`;

export const GET_LANDING_PAGE_RECOMMENDATIONS = gql`
  query getDiagnosticItemRecommendationsByPastOrders($mobileNumber: String!) {
    getDiagnosticItemRecommendationsByPastOrders(mobileNumber: $mobileNumber) {
      itemsData {
        itemName
        itemId
        allObservations {
          observationName
          mandatoryValue
          isHeader
          PrintOrder
        }
        diagnosticInclusions {
          itemId
          name
          allObservations {
            observationName
            mandatoryValue
            isHeader
            PrintOrder
          }
        }
        subCategoryList
        combinedLift
      }
    }
  }
`;

export const GET_PACKAGE_RECOMMENDATIONS = gql`
  query getDiagnosticPackageRecommendations(
    $itemId: Int!
    $cityId: Int!
    $groupPlan: DIAGNOSTICS_GROUPPLAN
  ) {
    getDiagnosticPackageRecommendations(
      itemId: $itemId
      cityId: $cityId
      groupPlan: $groupPlan
    ) {
      packageRecommendations {
        id
        itemId
        itemName
        gender
        rate
        itemRemarks
        diagnosticPricing {
          mrp
          price
          groupPlan
          startDate
          endDate
          status
          couponCode
          showSlashedPrice
          showDiscountPercent
          additionalCircleCashback {
            cashbackType
            cashbackValue
            offerDescription
            cashbackAmount
          }
        }
        inclusions
        diagnosticInclusions {
          name
          itemId
          testParameters
          allObservations {
            observationName
            mandatoryValue
            isHeader
            PrintOrder
          }
        }
        allObservations {
          observationName
          mandatoryValue
          isHeader
          PrintOrder
        }
        packageCalculatedMrp
        testPreparationData
        canonicalTag
      }
      labtestRecommendations {
        id
        itemId
        itemName
        gender
        rate
        itemRemarks
        diagnosticPricing {
          mrp
          price
          groupPlan
          startDate
          endDate
          status
          couponCode
          showSlashedPrice
          showDiscountPercent
          additionalCircleCashback {
            cashbackType
            cashbackValue
            offerDescription
            cashbackAmount
          }
        }
        inclusions
        diagnosticInclusions {
          name
          itemId
          testParameters
          allObservations {
            observationName
            mandatoryValue
          }
        }
        allObservations {
          observationName
          mandatoryValue
          isHeader
          PrintOrder
        }
        packageCalculatedMrp
        testPreparationData
        canonicalTag
      }
    }
  }
`;

export const GET_RECOMMENDED_DIAGNOSTICS_PRODUCTS = gql`
  mutation getDiagnosticItemRecommendations(
    $itemIds: [Int]!
    $genderFilters: [Gender]
  ) {
    getDiagnosticItemRecommendations(
      itemIds: $itemIds
      genderFilters: $genderFilters
    ) {
      itemsData {
        itemId
        itemName
        combinedLift
        gender
        imageUrl
        allObservations {
          observationName
          mandatoryValue
          isHeader
          PrintOrder
        }
        diagnosticInclusions {
          itemId
          allObservations {
            observationName
            mandatoryValue
            isHeader
            PrintOrder
          }
        }
      }
    }
  }
`;

export const GET_REPORT_TAT = gql`
  query getConfigurableReportTAT(
    $slotDateTimeInUTC: DateTime
    $cityId: Int!
    $pincode: Int!
    $itemIds: [Int]!
    $source: REPORT_TAT_SOURCE
    $latitude: Float
    $longitude: Float
    $bookingSource: DiagnosticsBookingSource
  ) {
    getConfigurableReportTAT(
      slotDateTimeInUTC: $slotDateTimeInUTC
      cityId: $cityId
      pincode: $pincode
      itemIds: $itemIds
      source: $source
      latitude: $latitude
      longitude: $longitude
      bookingSource: $bookingSource
    ) {
      maxReportTAT
      reportTATMessage
      preOrderReportTATMessage
      itemLevelReportTATs {
        itemId
        reportTATMessage
        reportTATInUTC
        preOrderReportTATMessage
      }
    }
  }
`;

export const GET_PACKAGE_INCLUSIONS_USING_CANONICAL_TAG = gql`
  query getInclusionsByCityIdAndCanonicalTag(
    $canonicalTags: [String]
    $cityID: Int!
  ) {
    getInclusionsByCityIdAndCanonicalTag(
      canonicalTags: $canonicalTags
      cityID: $cityID
    ) {
      inclusions {
        itemId
        requiredAttachment
        sampleRemarks
        sampleTypeName
        testParameters
        name
      }
    }
  }
`;

export const FIND_DIAGNOSTICS_BY_ITEM_ID_AND_CANONICAL_TAG = gql`
  query findDiagnosticsByCanonicalTagsAndCityID(
    $cityID: Int!
    $canonicalTags: [String]
  ) {
    findDiagnosticsByCanonicalTagsAndCityID(
      cityID: $cityID
      canonicalTags: $canonicalTags
    ) {
      diagnostics {
        canonicalTag
        id
        itemId
        itemName
        itemType
        rate
        itemType
        gender
        itemRemarks
        city
        state
        collectionType
        fromAgeInDays
        toAgeInDays
        testPreparationData
        testDescription
        inclusions
        packageCalculatedMrp
        diagnosticPricing {
          mrp
          price
          startDate
          endDate
          groupPlan
          status
          showSlashedPrice
          showDiscountPercent
          additionalCircleCashback {
            cashbackType
            cashbackValue
            offerDescription
            cashbackAmount
          }
        }
      }
    }
  }
`;

export const SEARCH_DIAGNOSTIC_ITEMS = gql`
  query searchDiagnosticItem(
    $keyword: String!
    $cityId: Int!
    $size: Int
    $itemType: DIAGNOSTICS_TYPE
    $topDeals: Boolean
    $categoryTypes: [String]
  ) {
    searchDiagnosticItem(
      keyword: $keyword
      cityId: $cityId
      size: $size
      itemType: $itemType
      topDeals: $topDeals
      categoryTypes: $categoryTypes
    ) {
      data {
        diagnostic_item_id
        diagnostic_item_name
        diagnostic_inclusions
        diagnostic_item_inclusion_ids
        diagnostic_item_alias
        diagnostic_item_gender
        product_score
        diagnostic_item_tags {
          display_colour
          display_icon
          display_text
        }
        diagnostic_item_price {
          status
          startDate
          endDate
          price
          mrp
          groupPlan
          showSlashedPrice
          showDiscountPercent
          additionalCircleCashback {
            cashbackType
            cashbackValue
            offerDescription
            cashbackAmount
          }
        }
        diagnostic_item_itemType
        diagnostic_item_alias_names
        diagnostic_item_toAgeInDays
        diagnostic_item_itemRemarks
        diagnostic_item_canonicalTag
        diagnostic_item_name_original
        diagnostic_item_fromAgeInDays
        diagnostic_item_collectionType
        diagnostic_item_testDescription
        diagnostic_item_testPreparationData
        diagnostic_item_packageCalculatedMrp
        diagnostic_inclusions_test_parameter_data {
          mandatoryValue
          observationName
        }
        testParametersCount
        testParametersCountWithHeaderLogic
        diagnostic_sub_category_list
        diagnostic_met_category_list
      }
      success
      matchedRecords
    }
  }
`;

export const GET_DIAGNOSTIC_SERVICEABILITY = gql`
  query getDiagnosticServiceability(
    $latitude: Float!
    $longitude: Float!
    $source: DiagnosticsBookingSource
  ) {
    getDiagnosticServiceability(
      latitude: $latitude
      longitude: $longitude
      source: $source
    ) {
      status
      serviceability {
        stateID
        state
        cityID
        city
      }
    }
  }
`;

export const GET_PATIENT_EPRESCRIPTIONS = gql`
  query GetPatientPrescriptions($patientId: String, $limit: Int) {
    getPatientPrescriptions(patientId: $patientId, limit: $limit) {
      response {
        doctorName
        patientName
        caseSheet {
          notes
          blobName
          consultType
          prescriptionGeneratedDate
          diagnosis {
            name
            __typename
          }
          diagnosticPrescription {
            itemname
            itemId
            __typename
          }
          doctorId
          doctorType
          followUp
          followUpAfterInDays
          followUpDate
          followUpConsultType
          id
          medicinePrescription {
            medicineConsumptionDurationInDays
            medicineDosage
            id
            medicineCustomDetails
            medicineConsumptionDurationUnit
            medicineFormTypes
            medicineFrequency
            medicineInstructions
            medicineName
            medicineTimings
            medicineToBeTaken
            medicineUnit
            routeOfAdministration
            __typename
          }
          symptoms {
            symptom
            since
            howOften
            severity
            details
            __typename
          }
          otherInstructions {
            instruction
            __typename
          }
          __typename
        }
      }
    }
  }
`;

export const GET_PATIENT_UPLOADED_PRECRIPTIONS = gql`
  query GetPatientUploadedPrescriptions(
    $patientId: ID!
    $records: [MedicalRecordType]
  ) {
    getPatientPrismMedicalRecords_V3(patientId: $patientId, records: $records) {
      prescriptions {
        response {
          id
          prescriptionName
          date
          prescribedBy
          notes
          prescriptionSource
          source
          siteDisplayName
          fileUrl
          prescriptionFiles {
            id
            fileName
            mimeType
            content
            byteContent
            __typename
          }
          __typename
        }
        errorCode
        errorMsg
        errorType
        __typename
      }
    }
  }
`;

export const GET_PRESCRIPTION_BLOB_URL = gql`
  mutation fetchBlobURLWithPRISMData($patientID: ID!, $fileUrl: String!) {
    fetchBlobURLWithPRISMData(patientId: $patientID, fileUrl: $fileUrl) {
      blobUrl
    }
  }
`;

export const ADD_PRESCRIPTION_RECORD = gql`
  mutation addPatientPrescriptionRecord(
    $AddPrescriptionRecordInput: AddPrescriptionRecordInput
  ) {
    addPatientPrescriptionRecord(
      addPrescriptionRecordInput: $AddPrescriptionRecordInput
    ) {
      status
    }
  }
`;

export const PLACE_DIAG_NON_CART_ORDER = gql`
  mutation PlaceDiagNonCartOrder(
    $diagnosticOrderInput: SaveBookHomeCollectionOrderInputv2
  ) {
    saveDiagnosticBookHCOrderv2(diagnosticOrderInput: $diagnosticOrderInput) {
      patientsObjWithOrderIDs {
        status
        patientID
        amount
        orderID
        displayID
        errorMessageToDisplay
      }
    }
  }
`;

export const GET_UPCOMING_SLOT_INFO = gql`
  query getUpcomingSlotInfo(
    $latitude: Float!
    $longitude: Float!
    $zipcode: String!
    $serviceability: DiagnosticsServiceability!
  ) {
    getUpcomingSlotInfo(
      latitude: $latitude
      longitude: $longitude
      zipcode: $zipcode
      serviceability: $serviceability
    ) {
      status
      slotInfo
    }
  }
`;

export const GET_ORDER_PHLEBO_DETAILS_BULK = gql`
  query getOrderPhleboDetailsBulk($diagnosticOrdersIds: [String]!) {
    getOrderPhleboDetailsBulk(diagnosticOrdersIds: $diagnosticOrdersIds) {
      orderPhleboDetailsBulk {
        orderPhleboDetails {
          id
          diagnosticOrdersId
          phleboOTP
          phleboTrackLink
          phleboRating
          diagnosticPhlebotomists {
            id
            name
            mobile
            rating
            vaccinationStatus
          }
          isPhleboChanged
        }
        phleboEta {
          estimatedArrivalTime
          durationInSeconds
        }
        allowCalling
        showPhleboDetails
        allowCallingETAText
        phleboDetailsETAText
      }
    }
  }
`;

export const GET_DIAGNOSTIC_CLOSED_ORDER_LIST = gql`
  query getDiagnosticClosedOrdersList(
    $mobileNumber: String!
    $skip: Int!
    $take: Int!
  ) {
    getDiagnosticClosedOrdersList(
      mobileNumber: $mobileNumber
      skip: $skip
      take: $take
    ) {
      closedOrders {
        id
        patientId
        preBookingId
        parentOrderId
        paymentOrderId
        orderStatus
        slotDateTimeInUTC
        labReportURL
        invoiceURL
        displayId
        patientObj {
          firstName
          lastName
        }
        diagnosticOrderPhlebotomists {
          phleboOTP
          phleboRating
          diagnosticPhlebotomists {
            name
            mobile
            id
          }
        }
        diagnosticOrderLineItems {
          itemObj {
            inclusions
            testPreparationData
          }
        }
        attributesObj {
          expectedReportGenerationTime
          reportGenerationTime
          reportTATHours
          reportTATMessage
          isMultiUhid
        }
        diagnosticOrderPaymentLinks {
          paymentLinkURL
          paymentLinkMessage
        }
      }
    }
  }
`;

export const GET_DIAGNOSTIC_OPEN_ORDER_LIST = gql`
  query getDiagnosticOpenOrdersList(
    $mobileNumber: String!
    $skip: Int!
    $take: Int!
  ) {
    getDiagnosticOpenOrdersList(
      mobileNumber: $mobileNumber
      skip: $skip
      take: $take
    ) {
      openOrders {
        id
        preBookingId
        patientId
        parentOrderId
        paymentOrderId
        orderStatus
        slotDateTimeInUTC
        labReportURL
        invoiceURL
        displayId
        patientObj {
          firstName
          lastName
        }
        diagnosticOrderPhlebotomists {
          phleboOTP
          phleboRating
          diagnosticPhlebotomists {
            name
            mobile
            id
          }
        }
        diagnosticOrderLineItems {
          itemObj {
            inclusions
            testPreparationData
          }
        }
        attributesObj {
          expectedReportGenerationTime
          reportGenerationTime
          reportTATHours
          reportTATMessage
          isMultiUhid
        }
        diagnosticOrderPaymentLinks {
          paymentLinkURL
          paymentLinkMessage
        }
      }
    }
  }
`;

export const GET_PATIENT_LATEST_PRESCRIPTIONS = gql`
  query getPatientLatestPrescriptions(
    $cityId: Int!
    $mobileNumber: String
    $limit: Int!
  ) {
    getPatientLatestPrescriptions(
      cityId: $cityId
      mobileNumber: $mobileNumber
      limit: $limit
    ) {
      doctorName
      doctorCredentials
      patientName
      prescriptionDateTime
      numberOfTests
      orderCount
      caseSheet {
        id
        blobName
        diagnosticPrescription {
          itemname
          testInstruction
          itemId
        }
        patientId
      }
    }
  }
`;

export const UPLOAD_FILE = gql`
  mutation UploadFile($fileType: String, $base64FileInput: String) {
    uploadFile(fileType: $fileType, base64FileInput: $base64FileInput) {
      filePath
    }
  }
`;

export const FIND_DIAGNOSTCS_WIDGET_PRICING = gql`
  query findDiagnosticsWidgetsPricing($itemIDs: [Int], $cityID: Int!) {
    findDiagnosticsWidgetsPricing(itemIDs: $itemIDs, cityID: $cityID) {
      diagnostics {
        itemId
        packageCalculatedMrp
        gender
        diagnosticPricing {
          startDate
          endDate
          price
          mrp
          groupPlan
          status
          showSlashedPrice
          showDiscountPercent
          additionalCircleCashback {
            cashbackType
            cashbackValue
            offerDescription
            cashbackAmount
          }
        }
      }
    }
  }
`;

export const FIND_DIAGNOSTICS_BY_ITEM_ID_AND_CITY_ID = gql`
  query findDiagnosticsByItemIDsAndCityID(
    $cityID: Int!
    $itemIDs: [Int]
    $pincode: Int
  ) {
    findDiagnosticsByItemIDsAndCityID(
      cityID: $cityID
      itemIDs: $itemIDs
      pincode: $pincode
    ) {
      diagnostics {
        id
        itemId
        itemName
        itemType
        rate
        itemType
        gender
        itemRemarks
        city
        state
        collectionType
        fromAgeInDays
        toAgeInDays
        testPreparationData
        testDescription
        inclusions
        imageUrl
        packageCalculatedMrp
        canonicalTag
        productScore
        subCategoryList
        allObservations {
          observationName
          mandatoryValue
          isHeader
          PrintOrder
        }
        diagnosticPricing {
          mrp
          price
          startDate
          endDate
          groupPlan
          status
          showSlashedPrice
          showDiscountPercent
          additionalCircleCashback {
            cashbackType
            cashbackValue
            offerDescription
            cashbackAmount
          }
        }
        diagnosticInclusions {
          itemId
          name
          allObservations {
            observationName
            mandatoryValue
            isHeader
            PrintOrder
          }
        }
      }
    }
  }
`;

export const GET_DIAGNOSTIC_SLOTS_CUSTOMIZED_V2 = gql`
  query getCustomizedSlotsv2(
    $patientAddressObj: patientAddressObj!
    $patientsObjWithLineItems: [patientObjWithLineItems]
    $billAmount: Float!
    $selectedDate: Date!
    $serviceability: DiagnosticsServiceability
    $bookingSource: DiagnosticsBookingSource
    $patientAddressID: String
    $slotByClusterConfig: Boolean
  ) {
    getCustomizedSlotsv2(
      patientAddressObj: $patientAddressObj
      patientsObjWithLineItems: $patientsObjWithLineItems
      billAmount: $billAmount
      selectedDate: $selectedDate
      serviceability: $serviceability
      bookingSource: $bookingSource
      patientAddressID: $patientAddressID
      slotByClusterConfig: $slotByClusterConfig
    ) {
      available_slots {
        slotDetail {
          slotDisplayTime
          internalSlots
        }
        isPaidSlot
      }
      slotDurationInMinutes
      distanceCharges
    }
  }
`;

export const UPDATE_PASSPORT_DETAILS = gql`
  mutation updatePassportDetails(
    $passportDetailsInput: [PassportDetailsInput]
  ) {
    updatePassportDetails(passportDetailsInput: $passportDetailsInput) {
      status
      displayId
      message
      data
    }
  }
`;

export const DIAG_VALIDATE_REORDER_FLOW = gql`
  query validateReorderFlow(
    $diagnosticOrdersId: String!
    $patientAddressId: String!
    $patientId: String!
  ) {
    validateReorderFlow(
      diagnosticOrdersId: $diagnosticOrdersId
      patientAddressId: $patientAddressId
      patientId: $patientId
    ) {
      activeItemsStatus
      addressInactiveDisplayMessage
      addressUnserviceableDisplayMessage
      inactiveItemIds
      isAddressActive
      isAddressServiceable
      isPatientActive
      itemsInactiveDisplayMessage
      patientInactiveDisplayMessage
    }
  }
`;

export const CREATE_REFUND_FOR_SAMPLEREJECTED = gql`
  mutation createRefundForSampleRejected(
    $accountName: String
    $accountNo: String
    $amountToRefund: Float
    $bankName: String
    $ifscCode: String
    $orderId: String
    $phNumber: String
    $upiId: String
    $type: RefundTypeForSampleRejected
  ) {
    createRefundForSampleRejected(
      accountName: $accountName
      accountNo: $accountNo
      amountToRefund: $amountToRefund
      bankName: $bankName
      ifscCode: $ifscCode
      orderId: $orderId
      phNumber: $phNumber
      upiId: $upiId
      type: $type
    )
  }
`;

export const GET_ACTIVE_TESTS = gql`
  query GetActiveDiagnosticsByCityID($cityID: Int!) {
    getActiveDiagnosticsByCityID(cityID: $cityID) {
      diagnostics {
        itemId
        itemName
        itemType
        productScore
      }
    }
  }
`;

export const GET_PACKAGE_RECOMMENDATIONS_V2 = gql`
  query GetDiagnosticPackageRecommendationsv2(
    $recommendationInputItems: [recommendationInputItem]!
    $cityId: Int!
    $mustHave: Boolean
  ) {
    getDiagnosticPackageRecommendationsv2(
      recommendationInputItems: $recommendationInputItems
      cityId: $cityId
      mustHave: $mustHave
    ) {
      packageRecommendations {
        id
        itemId
        itemName
        itemType
        rate
        itemType
        gender
        itemRemarks
        city
        state
        collectionType
        fromAgeInDays
        toAgeInDays
        testPreparationData
        testDescription
        inclusions
        imageUrl
        packageCalculatedMrp
        canonicalTag
        productScore
        subCategoryList
        allObservations {
          observationName
          mandatoryValue
          isHeader
          PrintOrder
        }
        diagnosticPricing {
          mrp
          price
          startDate
          endDate
          groupPlan
          status
          showSlashedPrice
          showDiscountPercent
          additionalCircleCashback {
            cashbackType
            cashbackValue
            offerDescription
            cashbackAmount
          }
        }
        diagnosticInclusions {
          itemId
          name
          allObservations {
            observationName
            mandatoryValue
            isHeader
            PrintOrder
          }
        }
      }
    }
  }
`;
